import React, { useEffect, useRef, useState } from "react";
import {
  Row,
  Col,
  Image,
  Form,
  Button,
  Modal,
  OverlayTrigger,
  Popover,
} from "react-bootstrap";
import { Link, useNavigate, useParams, useBlocker } from "react-router-dom";
import axios from "axios";
import { Formik, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import { jwtDecode } from "jwt-decode";
import Card from "../../../components/Card";
import url from "../../../configs/config";
import { roleTypes } from "../../../data/roleType";
import InputField from "../../../components/input/input-field";
import avatars1 from "../../../assets/images/avatars/01.png";
import CustomPhoneInput from "../../../components/input/phone-input";
import AlertNotificationSimple from "../../../components/alert/alert-notification-simple";
import FocusError from "../../../components/error/error-focus";
import "react-phone-input-2/lib/style.css";
import FadeLoaderComponent from "../../../components/loader-component";
import { defaultPermissions } from "../../../data/default-permission";
import WarehouseMultiSelect from "../../../components/input/warehouse-multi-select";
import * as SettingSelector from "../../../store/setting/selectors";
import { useSelector } from "react-redux";

const partialStyles = `
@keyframes expandIconBounce {
  0%, 100% { transform: rotate(270deg) translateX(0px); }
  50%       { transform: rotate(270deg) translateX(-5px); }
}

@keyframes warehouseBounceDown {
  0%, 100% { transform: translateY(0); }
  50%       { transform: translateY(7px); }
}  

.warehouse-partial-wrapper {
  position: relative;
  overflow: hidden;
  max-height: 210px;
  transition: max-height 0.4s ease;
}

.warehouse-partial-overlay {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100vw;
  height: 130px;
  background: linear-gradient(
    to bottom,
    rgba(255,255,255,0)   0%,
    rgba(255,255,255,0.82) 55%,
    rgba(255,255,255,0.97) 100%
  );
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding-bottom: 16px;
  pointer-events: none;
  z-index: 3;
}

.warehouse-bounce-btn {
  pointer-events: all;
  background: #3a57e8;
  border: none;
  border-radius: 50%;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(58,87,232,0.40);
  animation: warehouseBounceDown 1.15s ease-in-out infinite;
  transition: box-shadow 0.2s;
}

.warehouse-bounce-btn:hover {
  box-shadow: 0 6px 22px rgba(58,87,232,0.55);
  animation: warehouseBounceDown 0.5s ease-in-out infinite;
}

.warehouse-bounce-btn:focus {
  outline: none;
}
`;

const FormObserver = ({ dirty, setHasUnsavedChanges }) => {
  useEffect(() => {
    setHasUnsavedChanges(dirty);
  }, [dirty, setHasUnsavedChanges]);
  return null;
};

const AccountEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const alertRef = useRef(null);

  const rolePermissions = {
    [roleTypes.ADMIN]: [
      "receiving",
      "purchase_order",
      "product_request",
      "job",
      "rack_management",
      "system",
      "phase",
      "vendor",
      "manufacturer",
      "general_product_category",
      "general_product",
      "warehouse",
      "location",
      "stakeholder",
      "user",
    ],
    [roleTypes.SUPPLIER]: ["product_request", "purchase_order", "receiving"],
    [roleTypes.PURCHASING]: ["product_request", "purchase_order", "receiving"],
    [roleTypes.WAREHOUSE]: [
      "product_request",
      "rack_management",
      "warehouse",
      "system",
      "phase",
      "user",
      "receiving",
      "job",
      "location",
      "vendor",
      "stakeholder",
    ],
    [roleTypes.TECHNICIAN]: [
      "product_request",
      "rack_management",
      "warehouse",
      "system",
      "phase",
      "receiving",
      "job",
      "location",
      "vendor",
      "stakeholder",
    ],
  };

  const alertPermissionRef = useRef([]);
  const [collapsedStates, setCollapsedStates] = useState([]);
  const [isGeneralRole, setIsGeneralRole] = useState(false);
  const [loader, setLoader] = useState(true);
  const [errors, setErrors] = useState({});
  const [roles, setRoles] = useState([]);
  const [warehouseHeads, setWarehouseHeads] = useState([]);
  const [generalRoles, setGeneralRoles] = useState([]);
  const [warehouseIds, setWarehouseIds] = useState([]);
  const [warehouseError, setWarehouseError] = useState("");
  const [oldwarehouseIds, setOldWarehouseIds] = useState([]);
  const [userWarehousesRolesPermissions, setUserWarehousesRolesPermissions] =
    useState([]);
  const [user, setUser] = useState();
  const [warehouses, setWarehouses] = useState([]);
  const [userProfilePicture, setUserProfilePicture] = useState();
  const [permissions, setPermissions] = useState([]);
  const [originalUserPermissions, setOriginalUserPermissions] = useState({});
  const token = localStorage.getItem("coyote-token");
  const [decodedToken, setDecodedToken] = useState();
  const permissionsWarehouse = useSelector(SettingSelector?.set_permissions);
  const warehouseHasCreatePermission =
    permissionsWarehouse?.warehouse?.create === true;
  const [alert, setAlert] = useState({
    message: "",
    type: "",
    show: false,
    alertFor: "",
  });
  const [options, setOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);
  const [showPopover, setShowPopover] = useState(null);

  const [removedBackendWarehouseIds, setRemovedBackendWarehouseIds] = useState(
    [],
  );

  const [deleteConfirmModal, setDeleteConfirmModal] = useState({
    show: false,
    deletedWarehouses: [],
    pendingValues: null,
    pendingSetSubmitting: null,
  });

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    deletedWarehouses: [],
  });

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [showDiscardModal, setShowDiscardModal] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);
  const allowNavigationRef = useRef(false);

  const blocker = useBlocker(({ currentLocation, nextLocation }) => {
    if (allowNavigationRef.current) return false;
    return (
      hasUnsavedChanges && currentLocation.pathname !== nextLocation.pathname
    );
  });

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (hasUnsavedChanges) {
        e.preventDefault();
        e.returnValue = "";
        return "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, [hasUnsavedChanges]);

  useEffect(() => {
    if (blocker.state === "blocked") {
      if (hasUnsavedChanges && !allowNavigationRef.current) {
        setShowDiscardModal(true);
        setPendingNavigation(() => blocker.proceed);
      } else {
        blocker.reset();
        setShowDiscardModal(false);
        setPendingNavigation(null);
      }
    }
  }, [blocker.state, hasUnsavedChanges, blocker]);

  useEffect(() => {
    return () => {
      if (blocker.state === "blocked" && !allowNavigationRef.current)
        blocker.reset();
      allowNavigationRef.current = false;
    };
  }, [blocker]);

  const handleDiscardChanges = () => {
    if (blocker.state === "blocked") {
      allowNavigationRef.current = true;
      setShowDiscardModal(false);
      setPendingNavigation(null);
      if (pendingNavigation) {
        pendingNavigation();
      } else if (blocker.proceed) {
        blocker.proceed();
      }
    }
  };

  const handleCancelDiscard = () => {
    allowNavigationRef.current = false;
    if (blocker.state === "blocked") blocker.reset();
    setShowDiscardModal(false);
    setPendingNavigation(null);

    window.scrollTo({
      top: document.documentElement.scrollHeight,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    if (token && typeof token === "string") {
      try {
        const decoded = jwtDecode(token);
        setDecodedToken(decoded?.user);
      } catch (error) {
        console.error("Failed to decode token", error);
      }
    }
  }, [token]);

  const getWarehouses = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}warehouse/all/lists`,
        config,
      );
      setWarehouses(response.data.response.data);
    } catch (err) {
      handleError(err, "user-edit");
    }
  };

  const handleSetWarehouse = async (
    value,
    currentPermissions,
    currentFormWarehouses = [],
  ) => {
    const updatedWarehouses =
      currentFormWarehouses.length > 0
        ? [...currentFormWarehouses]
        : [...userWarehousesRolesPermissions];

    value.forEach((selectedWarehouseId) => {
      const warehouseExists = updatedWarehouses.some(
        (warehouse) => warehouse.warehouseId === selectedWarehouseId,
      );

      if (!warehouseExists) {
        const warehouseData =
          user?.userRolesWarehousesPermissions?.find(
            (warehouse) => warehouse.warehouseId === selectedWarehouseId,
          ) ||
          userWarehousesRolesPermissions?.find(
            (warehouse) => warehouse.warehouseId === selectedWarehouseId,
          );

        const initialValues = {};
        currentPermissions?.forEach((permission) => {
          const entitySlug = permission.slug;
          initialValues[entitySlug] = {};
          permission.permissions
            .map((p) => p.permission_slug)
            .forEach((action) => {
              initialValues[entitySlug][action] = false;
            });
        });

        updatedWarehouses.push({
          warehouseId: selectedWarehouseId,
          isWarehouseHead: warehouseData?.isWarehouseHead || 0,
          roles: warehouseData?.roles || [],
          permissions: warehouseData?.permissions || initialValues || {},
        });
      }
    });

    const finalWarehouses = updatedWarehouses.filter((warehouse) =>
      value.some((selectedId) => selectedId === warehouse.warehouseId),
    );
    return finalWarehouses;
  };

  const getPermissions = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}permission/${
          decodedToken?.roles.some(
            (role) => role.role_type === roleTypes.SUPER_ADMIN,
          )
            ? "all"
            : "active-user-permissions"
        }`,
        config,
      );
      return response.data.response.data;
    } catch (err) {
      handleError(err, "user-edit");
    }
  };

  const getRoles = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(`${url.backendURL}role/all`, config);
      setRoles(response.data.response.data);
      return response.data.response.data;
    } catch (err) {
      handleError(err, "user-edit");
    }
  };

  const getUserData = async () => {
    try {
      const config = { headers: { Authorization: `${token}` } };
      const response = await axios.get(
        `${url.backendURL}admin/user/${id}`,
        config,
      );

      const userData = response.data.response.data;
      const { profilePicture, warehouseRoles, ...otherData } = userData;
      otherData.warehouseIds = warehouseRoles?.map((w) => w.warehouseId) || [];

      const headWarehouses = warehouseRoles.filter(
        (w) => w.isWarehouseHead === 1,
      );
      if (headWarehouses.length > 0) {
        setWarehouseHeads(
          headWarehouses.map((w) => ({
            warehouseId: w.warehouseId,
            isWarehouseHead: w.isWarehouseHead,
          })),
        );
      }

      setWarehouseIds(otherData.warehouseIds || []);
      setOldWarehouseIds(otherData.warehouseIds || []);
      setCollapsedStates(
        otherData.warehouseIds?.map((_, index) =>
          index === 0 ? "partial" : true,
        ) ?? [],
      );

      const roleData = (await getRoles()) || [];
      const generalRoleTypes = [
        roleTypes.ADMIN,
        roleTypes.SUPPLIER,
        roleTypes.PURCHASING,
      ];
      const generalRoleIds = roleData
        .filter((role) => generalRoleTypes.includes(role.roleType))
        .map((role) => role.id);
      setGeneralRoles(generalRoleIds);

      otherData.generalRole = (warehouseRoles || []).some((warehouse) =>
        (warehouse.roles || []).some((roleId) =>
          generalRoleIds.includes(roleId),
        ),
      );

      if (otherData.generalRole) setIsGeneralRole(true);

      await getWarehouses();
      const allPermissions = (await getPermissions()) || [];
      const initialValues = {};
      allPermissions?.forEach((permission) => {
        const entitySlug = permission.slug;
        initialValues[entitySlug] = {};
        (permission.permissions || [])
          .map((p) => p.permission_slug)
          .forEach((action) => {
            initialValues[entitySlug][action] = false;
          });
      });

      const userRolesWarehousesPermissions =
        warehouseRoles?.map((warehouse) => {
          let rawPermissions = {};
          try {
            rawPermissions =
              typeof warehouse.permissions === "string"
                ? JSON.parse(warehouse.permissions)
                : warehouse.permissions || {};
          } catch (e) {
            console.error("Error parsing permissions", e);
          }

          const cleanedPermissions = {};
          allPermissions?.forEach((permission) => {
            const entitySlug = permission.slug;
            const validActions = (permission.permissions || []).map(
              (p) => p.permission_slug,
            );
            cleanedPermissions[entitySlug] = {};
            validActions.forEach((action) => {
              cleanedPermissions[entitySlug][action] =
                rawPermissions?.[entitySlug]?.[action] || false;
            });
          });

          return {
            warehouseId: warehouse.warehouseId || null,
            isWarehouseHead: warehouse.isWarehouseHead || 0,
            roles: warehouse.roles || [],
            permissions: cleanedPermissions,
          };
        }) || [];

      const originalPermissions = {};
      userRolesWarehousesPermissions.forEach((warehouse) => {
        if (warehouse.warehouseId && warehouse.permissions?.user) {
          originalPermissions[warehouse.warehouseId] = {
            ...warehouse.permissions.user,
          };
        }
      });

      setOriginalUserPermissions(originalPermissions);
      setPermissions(allPermissions);
      setUserProfilePicture(profilePicture);

      const rolesArray = userRolesWarehousesPermissions || [];
      const idsArray = otherData.warehouseIds || [];

      setUserWarehousesRolesPermissions(rolesArray);
      setWarehouseIds(idsArray);
      setOldWarehouseIds(idsArray);
      setCollapsedStates(
        idsArray.map((_, index) => (index === 0 ? "partial" : true)) ?? [],
      );

      setUser({
        ...otherData,
        warehouses: rolesArray,
        warehouseIds: idsArray,
      });

      setLoader(false);
    } catch (err) {
      console.error("getUserData Error:", err);
      if (
        err?.response?.data?.message ===
        "Forbidden. You do not have permission to access admin role user"
      ) {
        if (alertRef.current)
          alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        setAlert({
          message: err.response.data.message || "An error occurred",
          type: "danger",
          show: true,
          alertFor: "user-edit",
        });
        setTimeout(() => {
          window.location.href = `/dashboard/app/user-list`;
          setAlert({ show: false, alertFor: "", message: "", type: "" });
        }, 5000);
      }
      handleError(err, "user-edit");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (
      decodedToken?.roles.some(
        (role) =>
          role.role_type === roleTypes.SUPER_ADMIN ||
          role.role_type === roleTypes.ADMIN,
      )
    ) {
      getUserData();
    }
  }, [decodedToken, token]);

  const handleError = (err, alertFor) => {
    const { response } = err;
    if (alertRef.current)
      alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

    if (
      response?.data?.error === "jwt expired" ||
      response?.data?.error === "Unauthorized. User not found"
    ) {
      localStorage.removeItem("coyote-token");
      navigate(
        `/${decodedToken?.roles?.some((role) => role.role_type === roleTypes.SUPER_ADMIN) ? "admin" : "user"}/auth/sign-in`,
        { state: { status: "expired" } },
      );
    } else {
      setErrors(response?.data?.error || {});
      setAlert({
        message: response ? response.data.message : "An error occurred",
        type: "danger",
        show: true,
        alertFor,
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        5000,
      );
    }
  };

  const executeSubmit = async (values, setSubmitting, warehousesToDelete) => {
    if (
      !decodedToken?.roles.some(
        (role) =>
          role.role_type === roleTypes.SUPER_ADMIN ||
          role.role_type === roleTypes.ADMIN,
      )
    )
      return;

    setSubmitting(true);

    try {
      const submitValues = { ...values };
      delete submitValues.id;
      delete submitValues.status;
      delete submitValues.userRolesWarehousesPermissions;
      delete submitValues.generalRole;
      delete submitValues.warehouses;

      const data = new FormData();
      Object.keys(submitValues).forEach((key) => {
        if (key !== "profilePicture" && key !== "warehouseIds") {
          data.append(key, submitValues[key]);
        }
      });

      const fileInput = document.getElementById("profilePicture");
      if (values.profilePicture && fileInput?.files[0]) {
        data.append("profilePicture", fileInput.files[0]);
      }

      const warehousesToSubmit = (values.warehouses || []).map((wv) => {
        const w = { ...wv };
        w.generalRole =
          w?.warehouseId !== "" && w?.warehouseId !== null ? false : true;

        if (
          (w.isWarehouseHead === 0 || w.isWarehouseHead === false) &&
          w.warehouseId
        ) {
          if (w.permissions?.user) {
            const updatedPermissions = { ...w.permissions };
            Object.keys(updatedPermissions.user).forEach((action) => {
              updatedPermissions.user[action] = false;
            });
            w.permissions = updatedPermissions;
          }
        }
        return w;
      });

      const validWarehousesToDelete = (warehousesToDelete || []).filter(
        (wid) => wid !== null && wid !== undefined,
      );

      data.append("warehouses", JSON.stringify(warehousesToSubmit));
      data.append(
        "deletedWarehouseIds",
        JSON.stringify(validWarehousesToDelete),
      );

      const config = {
        headers: {
          Authorization: `${token}`,
          "Content-Type": "multipart/form-data",
        },
      };

      await axios.put(`${url.backendURL}admin/user`, data, config);

      const deletedWarehouseNames = validWarehousesToDelete.map(
        (warehouseId) =>
          warehouseOptions.find((opt) => opt.value === warehouseId)?.label ||
          `Warehouse #${warehouseId}`,
      );

      setRemovedBackendWarehouseIds([]);
      setOldWarehouseIds(warehouseIds);
      setHasUnsavedChanges(false);
      allowNavigationRef.current = true;
      if (blocker.state === "blocked") blocker.reset();

      if (alertRef.current)
        alertRef.current.scrollIntoView({ behavior: "smooth", block: "start" });

      setErrors({});
      setAlert({
        message: "User updated successfully",
        type: "success",
        show: true,
        alertFor: "user-edit",
      });
      setTimeout(
        () => setAlert({ show: false, alertFor: "", message: "", type: "" }),
        3000,
      );

      await getUserData();
      allowNavigationRef.current = false;

      if (deletedWarehouseNames.length > 0) {
        setDeleteModal({
          show: true,
          deletedWarehouses: deletedWarehouseNames,
        });
      }
    } catch (err) {
      handleError(err, "user-edit");
    }

    setSubmitting(false);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    const validWarehouseIds = (values.warehouseIds || []).filter(
      (wid) => wid !== null && wid !== undefined,
    );
    const hasGeneralRole = (values.warehouses || []).some((w) =>
      (w.roles || []).some((roleId) => (generalRoles || []).includes(roleId)),
    );

    if (!hasGeneralRole && validWarehouseIds.length === 0) {
      setWarehouseError("Warehouse is required");
      setSubmitting(false);
      return;
    }
    setWarehouseError("");

    const warehousesToDelete = removedBackendWarehouseIds.filter(
      (wid) => wid !== null && wid !== undefined,
    );

    if (warehousesToDelete.length > 0) {
      const warehouseNamesToDelete = warehousesToDelete.map(
        (wid) =>
          warehouseOptions.find((opt) => opt.value === wid)?.label ||
          `Warehouse #${wid}`,
      );

      setDeleteConfirmModal({
        show: true,
        deletedWarehouses: warehouseNamesToDelete,
        pendingValues: values,
        pendingSetSubmitting: setSubmitting,
      });
      setSubmitting(false);
    } else {
      await executeSubmit(values, setSubmitting, []);
    }
  };

  const handleConfirmDelete = async () => {
    const { pendingValues, pendingSetSubmitting } = deleteConfirmModal;
    const warehousesToDelete = removedBackendWarehouseIds.filter(
      (wid) => wid !== null && wid !== undefined,
    );

    setDeleteConfirmModal({
      show: false,
      deletedWarehouses: [],
      pendingValues: null,
      pendingSetSubmitting: null,
    });

    if (pendingValues && pendingSetSubmitting) {
      await executeSubmit(
        pendingValues,
        pendingSetSubmitting,
        warehousesToDelete,
      );
    }
  };

  const handleCancelDelete = () => {
    setDeleteConfirmModal({
      show: false,
      deletedWarehouses: [],
      pendingValues: null,
      pendingSetSubmitting: null,
    });
  };

  const validationSchema = () =>
    Yup.object().shape({
      profilePicture: Yup.mixed()
        .test(
          "fileType",
          "Image must be a valid file (jpeg, png, jpg)",
          (value) =>
            !value ||
            ["image/jpeg", "image/png", "image/jpg"].includes(value.type),
        )
        .nullable(),

      name: Yup.string()
        .min(1, "Name must be at least 1 character long")
        .max(255, "Name must not exceed 255 characters")
        .trim()
        .matches(
          /^(?=.*[A-Za-z])[A-Za-z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+$/,
          "Name must start with a letter and can include numbers, spaces, but cannot be entirely numbers",
        )
        .required("Name is required"),

      email: Yup.string()
        .trim()
        .required("Email is required")
        .email("Enter a valid email address")
        .test(
          "no-spaces",
          "Email may not contain any spaces",
          (value) => !value || value.trim() === value,
        )
        .test("min-domain-segments", "Enter a valid email address", (value) => {
          if (!value) return true;
          const parts = value.split("@");
          if (parts.length !== 2) return false;
          const domainSegments = parts[1].split(".");
          return (
            domainSegments.length >= 2 &&
            domainSegments.every((s) => s.length >= 2)
          );
        })
        .test("realistic-email", "Enter a valid email address", (value) => {
          if (!value) return true;
          const [local, domain] = value.split("@");
          if (!local || !domain) return false;
          if (/^\d+$/.test(local)) return false;
          if (local.length > 64) return false;
          if (!/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(domain)) return false;
          return true;
        }),

      phoneNumber: Yup.string()
        .trim()
        .matches(/^[0-9+\-]{10,15}$/, "Phone number must be 10 to 15 digits")
        .optional()
        .nullable()
        .test(
          "trim",
          "Phone number may not contain spaces at the beginning or end",
          (value) => value === (value && value.trim()),
        ),

      warehouses: Yup.array()
        .min(isGeneralRole ? 0 : 1, "At least one warehouse is required")
        .of(
          Yup.object().shape({
            warehouseId: Yup.number()
              .integer("Warehouse is invalid")
              .nullable(),

            isWarehouseHead: Yup.number()
              .integer("Warehouse head value is invalid")
              .nullable(),

            roles: Yup.array()
              .min(1, "At least one role is required")
              .required("Roles are required"),

            permissions: Yup.object()
              .shape(
                permissions.reduce((acc, permission) => {
                  const entitySlug = permission.slug;
                  const filteredActions = permission.permissions.map(
                    (p) => p.permission_slug,
                  );
                  if (filteredActions.length > 0) {
                    acc[entitySlug] = Yup.object(
                      filteredActions.reduce(
                        (obj, action) => ({
                          ...obj,
                          [action]: Yup.boolean().required(
                            `${action} is required for ${permission.label}`,
                          ),
                        }),
                        {},
                      ),
                    );
                  }
                  return acc;
                }, {}),
              )
              .test(
                "at-least-one-action-true",
                "At least one permission must be selected",
                function (value) {
                  const roles = this.parent.roles;
                  if (!roles || roles.length === 0) return true;
                  if (!value) return false;
                  return Object.values(value).some((entityPermissions) =>
                    Object.values(entityPermissions).some(
                      (action) => action === true,
                    ),
                  );
                },
              ),
          }),
        ),
    });

  useEffect(() => {
    const roleOptions =
      roles.length > 0 &&
      roles.map((role) => ({
        value: role.id,
        label: role.name,
        roleType: role.role_type || role.roleType,
      }));
    setOptions(roleOptions);
  }, [roles]);

  useEffect(() => {
    const warehouseOpts =
      warehouses.length > 0 &&
      warehouses.map((warehouse) => ({
        value: warehouse.id,
        label: warehouse.name,
        defaultHead: warehouse.default_head,
        headName: warehouse.head_names,
      }));
    setWarehouseOptions(warehouseOpts || []);
  }, [warehouses]);

  const toggleCollapseWarehouse = (index) => {
    setCollapsedStates((prevStates) =>
      prevStates.map((state, i) => {
        if (i === index) {
          return state === "partial" ? false : !state;
        }
        return state;
      }),
    );
  };

  const getPermissionsForRoles = (selectedRoleIds, rolesOptions) => {
    if (!selectedRoleIds || !rolesOptions || selectedRoleIds.length === 0)
      return [];
    const allPermissions = new Set();
    selectedRoleIds.forEach((roleId) => {
      const role = rolesOptions.find((opt) => opt.value === roleId);
      if (role && rolePermissions[role.roleType]) {
        rolePermissions[role.roleType].forEach((permission) =>
          allPermissions.add(permission),
        );
      }
    });
    return Array.from(allPermissions);
  };

  const roleTypeIsGeneral = (roleType) =>
    roleType === roleTypes.ADMIN ||
    roleType === roleTypes.SUPPLIER ||
    roleType === roleTypes.PURCHASING;

  const hadOriginalUserPermissions = (warehouseId) => {
    if (!originalUserPermissions[warehouseId]) return false;
    return Object.values(originalUserPermissions[warehouseId]).some(
      (value) => value === true,
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      if (showPopover !== null) setShowPopover(null);
    };
    window.addEventListener("scroll", handleScroll, true);
    return () => window.removeEventListener("scroll", handleScroll, true);
  }, [showPopover]);

  return (
    <>
      <style>{partialStyles}</style>

      <Modal
        show={deleteConfirmModal.show}
        onHide={handleCancelDelete}
        centered
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="custom-modal-header d-flex  items-center relative ">
          <Modal.Title>Confirm Warehouse Removal</Modal.Title>
          <button
            type="button"
            className="btn-close-svg "
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelDelete}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className=" px-4 pt-2">
          <p className="mb-3">
            You are about to remove this user&apos;s access from the following
            warehouse(s).
            <br />
            This action cannot be undone, and the user will lose access
            immediately.
            <br />
            Are you sure you want to continue?
          </p>
          <ul className="mb-0">
            {deleteConfirmModal.deletedWarehouses.map((name, i) => (
              <li key={i} className="text-danger fw-semibold">
                {name}
              </li>
            ))}
          </ul>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            type="button"
            className="btn btn-white me-4"
            variant="btn btn-white"
            onClick={handleCancelDelete}
            style={{
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
              borderColor: "#6c757d",
              color: "#6c757d",
            }}
          >
            Cancel
          </Button>
          <Button
            className="px-4 py-2"
            type="button"
            onClick={handleConfirmDelete}
            style={{
              backgroundColor: "#3a57e8",
              borderColor: "#3a57e8",
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
            }}
          >
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDiscardModal}
        onHide={handleCancelDiscard}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header className="custom-modal-header d-flex justify-content-center items-center relative">
          <Modal.Title>Unsaved Changes</Modal.Title>
          <button
            type="button"
            className="btn-close-svg"
            style={{ position: "absolute", right: "1rem" }}
            onClick={handleCancelDiscard}
            aria-label="Close"
          >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
            </svg>
          </button>
        </Modal.Header>
        <Modal.Body className="text-center px-4 pt-2">
          <p
            className="text-muted mb-4 px-2"
            style={{ fontSize: "1rem", lineHeight: "1.5" }}
          >
            You have unsaved changes. Do you want to discard these? Click update
            to save the changes.
          </p>
        </Modal.Body>
        <Modal.Footer className="border-0 justify-content-end pb-4 pt-0">
          <Button
            type="button"
            className="btn btn-white me-4"
            variant="btn btn-white"
            onClick={handleDiscardChanges}
            style={{
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
              borderColor: "#6c757d",
              color: "#6c757d",
            }}
          >
            Discard
          </Button>
          <Button
            className="px-4 py-2"
            style={{
              backgroundColor: "#3a57e8",
              borderColor: "#3a57e8",
              borderRadius: "25px",
              fontWeight: "500",
              minWidth: "100px",
            }}
            onClick={handleCancelDiscard}
          >
            Continue
          </Button>
        </Modal.Footer>
      </Modal>

      <div>
        <Formik
          enableReinitialize={true}
          initialValues={{
            ...user,
            warehouseIds: warehouseIds,
            generalRole: isGeneralRole,
            warehouses: userWarehousesRolesPermissions,
          }}
          validationSchema={validationSchema()}
          onSubmit={handleSubmit}
        >
          {({
            values,
            dirty,
            handleChange,
            handleBlur,
            setFieldValue,
            handleSubmit: formikHandleSubmit,
            isSubmitting,
            touched,
            errors: formikErrors,
            setFieldError,
            setFieldTouched,
          }) => (
            <Form onSubmit={formikHandleSubmit}>
              <FormObserver
                dirty={dirty}
                setHasUnsavedChanges={setHasUnsavedChanges}
              />
              <FocusError />
              <Row>
                <Col xl="3" lg="4">
                  <Card style={{ height: "-webkit-fill-available" }}>
                    <Card.Header className="d-flex justify-content-between">
                      <div className="header-title">
                        <h4 className="card-title">Edit User</h4>
                      </div>
                    </Card.Header>

                    <Card.Body>
                      {user && !loader && (
                        <>
                          <Form.Group className="form-group">
                            <div className="profile-img-edit position-relative">
                              <Image
                                className="theme-color-default-img profile-pic rounded avatar-100"
                                src={
                                  values?.profilePicture
                                    ? URL.createObjectURL(values.profilePicture)
                                    : userProfilePicture
                                      ? userProfilePicture
                                      : avatars1
                                }
                                alt="profile-pic"
                              />
                              <div
                                className="upload-icone bg-primary"
                                onClick={() =>
                                  document
                                    .getElementById("profilePicture")
                                    .click()
                                }
                              >
                                <svg
                                  className="upload-button"
                                  width="14"
                                  height="14"
                                  viewBox="0 0 24 24"
                                >
                                  <path
                                    fill="#ffffff"
                                    d="M14.06,9L15,9.94L5.92,19H5V18.08L14.06,9M17.66,3C17.41,3 17.15,3.1 16.96,3.29L15.13,5.12L18.88,8.87L20.71,7.04C21.1,6.65 21.1,6 20.71,5.63L18.37,3.29C18.17,3.09 17.92,3 17.66,3M14.06,6.19L3,17.25V21H6.75L17.81,9.94L14.06,6.19Z"
                                  />
                                </svg>
                                <Form.Control
                                  className="file-upload"
                                  id="profilePicture"
                                  type="file"
                                  accept=".png, .jpg, .jpeg"
                                  name="profilePicture"
                                  onChange={(e) =>
                                    setFieldValue(
                                      "profilePicture",
                                      e.currentTarget.files[0],
                                    )
                                  }
                                />
                              </div>
                            </div>
                            <div className="img-extension mt-3">
                              <div className="d-inline-block align-items-center">
                                <span>Only</span> <Link to="#">.jpg</Link>{" "}
                                <Link to="#">.png</Link>{" "}
                                <Link to="#">.jpeg</Link> <span>allowed</span>
                              </div>
                            </div>
                            <ErrorMessage
                              name="profilePicture"
                              component="div"
                              className="text-danger"
                            />
                            {errors?.profilePicture?.map((error, index) => (
                              <span
                                key={index}
                                className="w-100 mt-1 small text-danger"
                              >
                                {error}
                                <br />
                              </span>
                            ))}
                          </Form.Group>

                          {isGeneralRole === false && (
                            <Form.Group className="form-group">
                              <Form.Label>
                                Warehouses{" "}
                                <span className="text-danger">*</span>
                              </Form.Label>
                              <WarehouseMultiSelect
                                id="warehouses"
                                name="warehouses"
                                options={warehouseOptions}
                                isMulti={true}
                                isClearable={false}
                                value={values.warehouseIds || []}
                                warehouseIds={oldwarehouseIds}
                                onChange={async (value) => {
                                  const previousIds = values.warehouseIds || [];
                                  const removedId = previousIds.find(
                                    (pid) => !value.includes(pid),
                                  );

                                  if (removedId) {
                                    if (oldwarehouseIds.includes(removedId)) {
                                      setRemovedBackendWarehouseIds((prev) =>
                                        prev.includes(removedId)
                                          ? prev
                                          : [...prev, removedId],
                                      );
                                    }
                                  }

                                  if (removedBackendWarehouseIds.length > 0) {
                                    const reAdded =
                                      removedBackendWarehouseIds.filter((rid) =>
                                        value.includes(rid),
                                      );
                                    if (reAdded.length > 0) {
                                      setRemovedBackendWarehouseIds((prev) =>
                                        prev.filter(
                                          (rid) => !reAdded.includes(rid),
                                        ),
                                      );
                                    }
                                  }

                                  setFieldValue("warehouseIds", value);
                                  setWarehouseError("");
                                  setCollapsedStates(
                                    value?.map((warehouseId, idx) => {
                                      const isOld =
                                        oldwarehouseIds.includes(warehouseId);
                                      if (idx === 0 && isOld) return "partial";
                                      return isOld;
                                    }),
                                  );
                                  // Removed setWarehouseIds(value) to prevent Formik reset
                                  const updatedWarehouses =
                                    await handleSetWarehouse(
                                      value,
                                      permissions,
                                      values.warehouses,
                                    );
                                  setFieldValue(
                                    "warehouses",
                                    updatedWarehouses,
                                  );
                                }}
                                onBlur={handleBlur}
                                placeholder={
                                  warehouseOptions.length === 0 ? (
                                    <span>No warehouse found</span>
                                  ) : (
                                    "Select Warehouse(s)..."
                                  )
                                }
                                noOptionsMessage={({ inputValue }) => (
                                  <div style={{ textAlign: "center" }}>
                                    <span style={{ color: "#666" }}>
                                      {warehouseOptions.length === 0 ? (
                                        <>
                                          No warehouse found.
                                          {(warehouseHasCreatePermission ||
                                            decodedToken?.roles.some(
                                              (role) =>
                                                role.role_type ===
                                                roleTypes.SUPER_ADMIN,
                                            )) && (
                                            <span>
                                              {" "}
                                              <Link
                                                to="/dashboard/app/warehouse-add"
                                                style={{
                                                  color: "#007bff",
                                                  textDecoration: "none",
                                                  cursor: "pointer",
                                                }}
                                              >
                                                Add new
                                              </Link>
                                            </span>
                                          )}
                                        </>
                                      ) : inputValue ? (
                                        "No warehouse found"
                                      ) : (
                                        "No warehouse found"
                                      )}
                                    </span>
                                  </div>
                                )}
                              />
                              {warehouseError && (
                                <div className="text-danger small mt-1">
                                  {warehouseError}
                                </div>
                              )}
                              {formikErrors?.warehouses &&
                                typeof formikErrors.warehouses === "string" && (
                                  <div className="text-danger small mt-1">
                                    {formikErrors.warehouses}
                                  </div>
                                )}
                            </Form.Group>
                          )}
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>

                <Col xl="9" lg="8" ref={alertRef} className="d-flex">
                  <div style={{ width: "100%", display: "grid" }}>
                    <Card>
                      <Card.Header className="d-flex justify-content-between">
                        <div
                          className="breadcrumb header-title"
                          style={{ cursor: "pointer" }}
                        >
                          <h4
                            onClick={() => navigate("/dashboard/app/user-list")}
                            className="text-primary card-title"
                            style={{ cursor: "pointer" }}
                          >
                            <span>User</span>
                          </h4>
                          <h4 className="mx-2 card-title">{">"}</h4>
                          <h4 className="card-title">User Information</h4>
                        </div>
                      </Card.Header>

                      <Card.Body>
                        {alert.alertFor === "user-edit" && (
                          <AlertNotificationSimple
                            type={alert.type}
                            message={alert.message}
                            show={alert.show}
                            onClose={() => setAlert({ ...alert, show: false })}
                          />
                        )}
                        {user && !loader && (
                          <div className="new-user-info">
                            <div className="row">
                              <InputField
                                className="col-md-6 form-group"
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                value={values.name}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                errorMessage={errors?.name}
                                label="Name"
                              />
                              <InputField
                                className="col-md-6 form-group"
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={values.email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                asterick={true}
                                disabled={true}
                                errorMessage={errors?.email}
                                label="Email"
                              />
                              <Row>
                                <Form.Group className="col-md-6 form-group">
                                  <Form.Label htmlFor="phoneNumber">
                                    Phone Number
                                  </Form.Label>
                                  <CustomPhoneInput
                                    id="phoneNumber"
                                    name="phoneNumber"
                                    value={values.phoneNumber}
                                    onChange={(value) =>
                                      setFieldValue("phoneNumber", value)
                                    }
                                    onBlur={handleBlur}
                                    placeholder="Enter phone number"
                                    country="us"
                                    isValid={(value, country) => {
                                      if (value.match(/12345/))
                                        return `Invalid value: ${value}, ${country.name}`;
                                      if (value.match(/1234/)) return false;
                                      return true;
                                    }}
                                  />
                                  <ErrorMessage
                                    name="phoneNumber"
                                    component="div"
                                    className="text-danger"
                                  />
                                  {errors?.phoneNumber?.map((error, index) => (
                                    <span
                                      key={index}
                                      className="w-100 mt-1 small text-danger"
                                    >
                                      {error}
                                      <br />
                                    </span>
                                  ))}
                                </Form.Group>
                              </Row>
                            </div>
                            <hr />
                          </div>
                        )}
                        {loader && <FadeLoaderComponent />}
                      </Card.Body>
                    </Card>
                  </div>
                </Col>
              </Row>

              {!loader &&
                (values.warehouses || []).map((warehouseItem, index) => {
                  const userWarehousesRolesPermission = warehouseItem;
                  const isPartial = collapsedStates[index] === "partial";
                  const isCollapsed = collapsedStates[index] === true;

                  return (
                    <Row key={index}>
                      <Col xl="12" lg="12" className="d-flex">
                        <div style={{ width: "100%", display: "grid" }}>
                          <Card>
                            <Card.Header className="d-flex justify-content-between pb-3">
                              <div className="header-title">
                                <h4 className="card-title">
                                  {warehouseItem.warehouseId &&
                                  warehouseOptions.length > 0
                                    ? warehouseOptions.find(
                                        (opt) =>
                                          opt.value ===
                                          warehouseItem.warehouseId,
                                      )?.label
                                    : options.length > 0 &&
                                      options
                                        .find(
                                          (opt) =>
                                            opt.value ===
                                            warehouseItem?.roles?.[0],
                                        )
                                        ?.label?.replace(/\b\w/g, (c) =>
                                          c.toUpperCase(),
                                        )}
                                </h4>
                              </div>
                              <div>
                                {collapsedStates[index] ? (
                                  <>
                                    <div
                                      onClick={() =>
                                        toggleCollapseWarehouse(index)
                                      }
                                      className="sidebar-toggle"
                                      style={{
                                        position: "initial",
                                        marginRight: "1.5rem",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <i
                                        className="icon"
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          display: "flex",
                                          animation:
                                            "expandIconBounce 1.1s ease-in-out infinite",
                                        }}
                                      >
                                        <svg
                                          width="20"
                                          className="icon-20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M4.25 12.2744L19.25 12.2744"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </i>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <div
                                      className="sidebar-toggle"
                                      onClick={() =>
                                        toggleCollapseWarehouse(index)
                                      }
                                      style={{
                                        position: "initial",
                                        marginRight: "1.5rem",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <i
                                        className="icon"
                                        style={{
                                          width: "30px",
                                          height: "30px",
                                          alignItems: "center",
                                          justifyContent: "center",
                                          display: "flex",
                                          transform: "rotate(90deg)",
                                        }}
                                      >
                                        <svg
                                          width="20"
                                          className="icon-20"
                                          height="20"
                                          viewBox="0 0 24 24"
                                          fill="none"
                                          xmlns="http://www.w3.org/2000/svg"
                                        >
                                          <path
                                            d="M4.25 12.2744L19.25 12.2744"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                          <path
                                            d="M10.2998 18.2988L4.2498 12.2748L10.2998 6.24976"
                                            stroke="currentColor"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                          ></path>
                                        </svg>
                                      </i>
                                    </div>
                                  </>
                                )}
                              </div>
                            </Card.Header>

                            {!isCollapsed && (
                              <Card.Body
                                style={{
                                  padding: isPartial
                                    ? "1rem 1.25rem 0"
                                    : undefined,
                                }}
                              >
                                {user && !loader && (
                                  <div
                                    className="user-permission"
                                    ref={(el) =>
                                      (alertPermissionRef.current[index] = el)
                                    }
                                  >
                                    <div
                                      className={
                                        isPartial
                                          ? "warehouse-partial-wrapper"
                                          : ""
                                      }
                                      style={!isPartial ? {} : undefined}
                                    >
                                      <div className="row">
                                        {(warehouseItem.warehouseId ||
                                          (!warehouseItem.warehouseId &&
                                            warehouseItem.roles?.length >
                                              0)) && (
                                          <>
                                            <Row className="mb-3">
                                              {/* Roles */}
                                              <Col>
                                                <h5 className="align-items-center mb-4">
                                                  Roles
                                                </h5>
                                                <div
                                                  className="d-flex flex-wrap gap-4"
                                                  id="roles-section"
                                                >
                                                  {options?.map((role) => {
                                                    const isChecked =
                                                      warehouseItem?.roles?.includes(
                                                        role?.value,
                                                      );
                                                    const isGeneralRoleType =
                                                      roleTypeIsGeneral(
                                                        role.roleType,
                                                      );
                                                    const userRoles =
                                                      userWarehousesRolesPermission?.roles ||
                                                      [];
                                                    const hasGeneralRole =
                                                      generalRoles?.some(
                                                        (gid) =>
                                                          userRoles.includes(
                                                            gid,
                                                          ),
                                                      );

                                                    if (
                                                      !userWarehousesRolesPermission?.warehouseId
                                                    ) {
                                                      if (
                                                        userWarehousesRolesPermission
                                                          ?.roles?.length ===
                                                          1 &&
                                                        hasGeneralRole &&
                                                        !isGeneralRoleType
                                                      )
                                                        return null;
                                                    } else {
                                                      if (
                                                        hasGeneralRole &&
                                                        isGeneralRoleType
                                                      )
                                                        return null;
                                                      if (isGeneralRoleType)
                                                        return null;
                                                    }

                                                    return (
                                                      <div
                                                        key={role?.value}
                                                        className="role-checkbox-item"
                                                      >
                                                        <Form.Check
                                                          type="checkbox"
                                                          id={`role-${warehouseItem?.warehouseId}-${role?.value}`}
                                                          name={`warehouses[${index}].roles`}
                                                          label={role?.label}
                                                          checked={isChecked}
                                                          disabled={
                                                            !warehouseItem?.warehouseId
                                                          }
                                                          onChange={() => {
                                                            setErrors(
                                                              (prev) => ({
                                                                ...prev,
                                                                roles:
                                                                  undefined,
                                                                warehouseRoles:
                                                                  undefined,
                                                              }),
                                                            );
                                                            const isOldWarehouse =
                                                              oldwarehouseIds?.includes(
                                                                warehouseItem?.warehouseId,
                                                              );
                                                            const isRoleBeingRemoved =
                                                              isChecked;

                                                            if (
                                                              isRoleBeingRemoved &&
                                                              role?.label?.toLowerCase() ===
                                                                "warehouse-head"
                                                            ) {
                                                              setFieldValue(
                                                                `warehouses[${index}].isWarehouseHead`,
                                                                0,
                                                              );
                                                            }

                                                            let updatedRoles =
                                                              isRoleBeingRemoved
                                                                ? warehouseItem.roles.filter(
                                                                    (r) =>
                                                                      r !==
                                                                      role?.value,
                                                                  )
                                                                : [
                                                                    ...warehouseItem.roles,
                                                                    role?.value,
                                                                  ];

                                                            if (
                                                              warehouseItem.isWarehouseHead ===
                                                                1 &&
                                                              !isRoleBeingRemoved
                                                            ) {
                                                              const warehouseHeadRole =
                                                                options.find(
                                                                  (opt) =>
                                                                    opt.label?.toLowerCase() ===
                                                                    "warehouse-head",
                                                                );
                                                              if (
                                                                warehouseHeadRole &&
                                                                !updatedRoles.includes(
                                                                  warehouseHeadRole.value,
                                                                )
                                                              ) {
                                                                updatedRoles.push(
                                                                  warehouseHeadRole.value,
                                                                );
                                                              }
                                                            }

                                                            if (
                                                              !isOldWarehouse
                                                            ) {
                                                              const allowedPermissions =
                                                                getPermissionsForRoles(
                                                                  updatedRoles,
                                                                  options,
                                                                );
                                                              let initializedPermissions =
                                                                {
                                                                  ...warehouseItem.permissions,
                                                                };

                                                              if (
                                                                isRoleBeingRemoved
                                                              ) {
                                                                const removedRolePermissions =
                                                                  getPermissionsForRoles(
                                                                    [
                                                                      role?.value,
                                                                    ],
                                                                    options,
                                                                  );
                                                                const remainingRolePermissions =
                                                                  getPermissionsForRoles(
                                                                    updatedRoles.filter(
                                                                      (r) =>
                                                                        r !==
                                                                        role?.value,
                                                                    ),
                                                                    options,
                                                                  );
                                                                removedRolePermissions.forEach(
                                                                  (
                                                                    entitySlug,
                                                                  ) => {
                                                                    if (
                                                                      !remainingRolePermissions.includes(
                                                                        entitySlug,
                                                                      ) &&
                                                                      initializedPermissions[
                                                                        entitySlug
                                                                      ]
                                                                    ) {
                                                                      Object.keys(
                                                                        initializedPermissions[
                                                                          entitySlug
                                                                        ],
                                                                      ).forEach(
                                                                        (
                                                                          action,
                                                                        ) => {
                                                                          initializedPermissions[
                                                                            entitySlug
                                                                          ][
                                                                            action
                                                                          ] =
                                                                            false;
                                                                        },
                                                                      );
                                                                    }
                                                                  },
                                                                );
                                                                if (
                                                                  role?.label?.toLowerCase() ===
                                                                    "warehouse-head" &&
                                                                  initializedPermissions.user
                                                                ) {
                                                                  Object.keys(
                                                                    initializedPermissions.user,
                                                                  ).forEach(
                                                                    (
                                                                      action,
                                                                    ) => {
                                                                      initializedPermissions.user[
                                                                        action
                                                                      ] = false;
                                                                    },
                                                                  );
                                                                }
                                                              } else {
                                                                const selectedRolesData =
                                                                  updatedRoles
                                                                    .map(
                                                                      (
                                                                        roleValue,
                                                                      ) => {
                                                                        const roleOption =
                                                                          options.find(
                                                                            (
                                                                              opt,
                                                                            ) =>
                                                                              opt.value ===
                                                                              roleValue,
                                                                          );
                                                                        return roleOption
                                                                          ? defaultPermissions.find(
                                                                              (
                                                                                rp,
                                                                              ) =>
                                                                                rp.roleType ===
                                                                                roleOption.roleType,
                                                                            )
                                                                          : null;
                                                                      },
                                                                    )
                                                                    .filter(
                                                                      Boolean,
                                                                    );

                                                                selectedRolesData.forEach(
                                                                  (
                                                                    rolePermission,
                                                                  ) => {
                                                                    rolePermission?.predefinedPermissions?.forEach(
                                                                      ({
                                                                        entity,
                                                                        actions,
                                                                      }) => {
                                                                        if (
                                                                          entity ===
                                                                          "user"
                                                                        )
                                                                          return;
                                                                        if (
                                                                          allowedPermissions.includes(
                                                                            entity,
                                                                          )
                                                                        ) {
                                                                          if (
                                                                            !initializedPermissions[
                                                                              entity
                                                                            ]
                                                                          )
                                                                            initializedPermissions[
                                                                              entity
                                                                            ] =
                                                                              {};
                                                                          actions.forEach(
                                                                            (
                                                                              action,
                                                                            ) => {
                                                                              initializedPermissions[
                                                                                entity
                                                                              ][
                                                                                action
                                                                              ] =
                                                                                true;
                                                                              if (
                                                                                (rolePermission.roleType ===
                                                                                  roleTypes.ADMIN ||
                                                                                  rolePermission.roleType ===
                                                                                    roleTypes.SUPER_ADMIN) &&
                                                                                entity ===
                                                                                  "warehouse"
                                                                              ) {
                                                                                initializedPermissions[
                                                                                  "warehouse"
                                                                                ][
                                                                                  "create"
                                                                                ] =
                                                                                  true;
                                                                                initializedPermissions[
                                                                                  "warehouse"
                                                                                ][
                                                                                  "delete"
                                                                                ] =
                                                                                  true;
                                                                              }
                                                                            },
                                                                          );
                                                                        }
                                                                      },
                                                                    );
                                                                  },
                                                                );
                                                              }

                                                              setFieldValue(
                                                                `warehouses[${index}].roles`,
                                                                updatedRoles,
                                                              );
                                                              setFieldValue(
                                                                `warehouses[${index}].permissions`,
                                                                initializedPermissions,
                                                              );

                                                              if (
                                                                !updatedRoles.some(
                                                                  (roleId) =>
                                                                    options.some(
                                                                      (opt) =>
                                                                        opt.value ===
                                                                          roleId &&
                                                                        opt.label ===
                                                                          "warehouse-head",
                                                                    ),
                                                                )
                                                              ) {
                                                                setFieldValue(
                                                                  `warehouses[${index}].isWarehouseHead`,
                                                                  0,
                                                                );
                                                              }
                                                            } else {
                                                              setFieldValue(
                                                                `warehouses[${index}].roles`,
                                                                updatedRoles,
                                                              );

                                                              if (
                                                                isRoleBeingRemoved &&
                                                                role?.label?.toLowerCase() ===
                                                                  "warehouse-head"
                                                              ) {
                                                                const hasAdminRole =
                                                                  updatedRoles.some(
                                                                    (rv) => {
                                                                      const r =
                                                                        options.find(
                                                                          (
                                                                            opt,
                                                                          ) =>
                                                                            opt.value ===
                                                                            rv,
                                                                        );
                                                                      return (
                                                                        r?.roleType ===
                                                                        roleTypes.ADMIN
                                                                      );
                                                                    },
                                                                  );

                                                                if (
                                                                  !hasAdminRole &&
                                                                  warehouseItem
                                                                    .permissions
                                                                    ?.user
                                                                ) {
                                                                  const hadOriginalPerms =
                                                                    hadOriginalUserPermissions(
                                                                      warehouseItem.warehouseId,
                                                                    );
                                                                  const updatedPermissions =
                                                                    {
                                                                      ...warehouseItem.permissions,
                                                                    };
                                                                  if (
                                                                    hadOriginalPerms &&
                                                                    originalUserPermissions[
                                                                      warehouseItem
                                                                        .warehouseId
                                                                    ]
                                                                  ) {
                                                                    updatedPermissions.user =
                                                                      {
                                                                        ...originalUserPermissions[
                                                                          warehouseItem
                                                                            .warehouseId
                                                                        ],
                                                                      };
                                                                  } else {
                                                                    Object.keys(
                                                                      updatedPermissions.user,
                                                                    ).forEach(
                                                                      (
                                                                        action,
                                                                      ) => {
                                                                        updatedPermissions.user[
                                                                          action
                                                                        ] =
                                                                          false;
                                                                      },
                                                                    );
                                                                  }
                                                                  setFieldValue(
                                                                    `warehouses[${index}].permissions`,
                                                                    updatedPermissions,
                                                                  );
                                                                }
                                                              }

                                                              if (
                                                                !updatedRoles.some(
                                                                  (roleId) =>
                                                                    options.some(
                                                                      (opt) =>
                                                                        opt.value ===
                                                                          roleId &&
                                                                        opt.label ===
                                                                          "warehouse-head",
                                                                    ),
                                                                )
                                                              ) {
                                                                setFieldValue(
                                                                  `warehouses[${index}].isWarehouseHead`,
                                                                  0,
                                                                );
                                                              }
                                                            }

                                                            setTimeout(() => {
                                                              setFieldTouched(
                                                                `warehouses[${index}].roles`,
                                                                true,
                                                                false,
                                                              );
                                                              if (
                                                                updatedRoles &&
                                                                updatedRoles.length >
                                                                  0
                                                              ) {
                                                                setFieldError(
                                                                  `warehouses[${index}].roles`,
                                                                  undefined,
                                                                );
                                                              } else {
                                                                setFieldError(
                                                                  `warehouses[${index}].roles`,
                                                                  "At least one role is required",
                                                                );
                                                                setFieldError(
                                                                  `warehouses[${index}].permissions`,
                                                                  undefined,
                                                                );
                                                              }
                                                            }, 50);
                                                          }}
                                                          onBlur={handleBlur}
                                                          className="mb-2"
                                                        />
                                                      </div>
                                                    );
                                                  })}
                                                </div>
                                                <ErrorMessage
                                                  name={`warehouses[${index}].roles`}
                                                  component="div"
                                                  className="text-danger small"
                                                />
                                              </Col>

                                              {warehouseOptions.find(
                                                (opt) =>
                                                  opt.value ===
                                                  warehouseItem?.warehouseId,
                                              )?.label && (
                                                <Col>
                                                  <h5 className="align-items-center mb-4">
                                                    Main Head
                                                  </h5>
                                                  <div
                                                    className="d-flex flex-wrap gap-4"
                                                    id="warehouse-head-section"
                                                  >
                                                    {(() => {
                                                      const isDisabled =
                                                        !warehouseItem?.warehouseId ||
                                                        (warehouseOptions.find(
                                                          (wh) =>
                                                            wh.value ===
                                                              warehouseItem?.warehouseId &&
                                                            wh.defaultHead ===
                                                              1 &&
                                                            !warehouseHeads.some(
                                                              (wh2) =>
                                                                wh2.warehouseId ===
                                                                warehouseItem?.warehouseId,
                                                            ),
                                                        )
                                                          ? true
                                                          : false);

                                                      const popover = (
                                                        <Popover
                                                          id={`popover-main-head-${warehouseItem?.warehouseId}`}
                                                        >
                                                          <Popover.Body>
                                                            Only one Main Head
                                                            is allowed per
                                                            warehouse.
                                                            <br />
                                                            The current Main
                                                            Head is{" "}
                                                            <strong>
                                                              {
                                                                warehouseOptions.find(
                                                                  (w) =>
                                                                    w.value ===
                                                                    warehouseItem?.warehouseId,
                                                                )?.headName
                                                              }
                                                            </strong>
                                                            .<br />
                                                            To assign a new Main
                                                            Head, please uncheck
                                                            this role for{" "}
                                                            <strong>
                                                              {
                                                                warehouseOptions.find(
                                                                  (w) =>
                                                                    w.value ===
                                                                    warehouseItem?.warehouseId,
                                                                )?.headName
                                                              }
                                                            </strong>{" "}
                                                            first.
                                                          </Popover.Body>
                                                        </Popover>
                                                      );

                                                      const checkbox = (
                                                        <Form.Check
                                                          type="checkbox"
                                                          id={`isWarehouseHead-${index}`}
                                                          name={`warehouses[${index}].isWarehouseHead`}
                                                          checked={
                                                            warehouseItem.isWarehouseHead
                                                          }
                                                          disabled={isDisabled}
                                                          onClick={() => {
                                                            const newValue =
                                                              warehouseItem.isWarehouseHead ===
                                                              1
                                                                ? 0
                                                                : 1;

                                                            if (
                                                              newValue === 1
                                                            ) {
                                                              const warehouseHeadRole =
                                                                options.find(
                                                                  (opt) =>
                                                                    opt.label?.toLowerCase() ===
                                                                    "warehouse-head",
                                                                );
                                                              if (
                                                                warehouseHeadRole &&
                                                                !warehouseItem.roles.includes(
                                                                  warehouseHeadRole.value,
                                                                )
                                                              ) {
                                                                const updatedRoles =
                                                                  [
                                                                    ...warehouseItem.roles,
                                                                    warehouseHeadRole.value,
                                                                  ];
                                                                setFieldValue(
                                                                  `warehouses[${index}].roles`,
                                                                  updatedRoles,
                                                                );

                                                                const allowedPermissions =
                                                                  getPermissionsForRoles(
                                                                    updatedRoles,
                                                                    options,
                                                                  );
                                                                let initializedPermissions =
                                                                  {
                                                                    ...warehouseItem.permissions,
                                                                  };

                                                                const warehouseHeadDefaultPerms =
                                                                  defaultPermissions.find(
                                                                    (rp) =>
                                                                      rp.roleType ===
                                                                      roleTypes.WAREHOUSE,
                                                                  );
                                                                if (
                                                                  warehouseHeadDefaultPerms
                                                                ) {
                                                                  warehouseHeadDefaultPerms.predefinedPermissions.forEach(
                                                                    ({
                                                                      entity,
                                                                      actions,
                                                                    }) => {
                                                                      if (
                                                                        entity ===
                                                                        "user"
                                                                      )
                                                                        return;
                                                                      if (
                                                                        allowedPermissions.includes(
                                                                          entity,
                                                                        )
                                                                      ) {
                                                                        if (
                                                                          !initializedPermissions[
                                                                            entity
                                                                          ]
                                                                        )
                                                                          initializedPermissions[
                                                                            entity
                                                                          ] =
                                                                            {};
                                                                        actions.forEach(
                                                                          (
                                                                            action,
                                                                          ) => {
                                                                            initializedPermissions[
                                                                              entity
                                                                            ][
                                                                              action
                                                                            ] =
                                                                              true;
                                                                          },
                                                                        );
                                                                      }
                                                                    },
                                                                  );
                                                                }
                                                                setFieldValue(
                                                                  `warehouses[${index}].permissions`,
                                                                  initializedPermissions,
                                                                );
                                                              }
                                                            }

                                                            setFieldValue(
                                                              `warehouses[${index}].isWarehouseHead`,
                                                              newValue,
                                                            );

                                                            if (
                                                              newValue === 0
                                                            ) {
                                                              const hasAdminRole =
                                                                warehouseItem.roles?.some(
                                                                  (rv) => {
                                                                    const r =
                                                                      options.find(
                                                                        (opt) =>
                                                                          opt.value ===
                                                                          rv,
                                                                      );
                                                                    return (
                                                                      r?.roleType ===
                                                                      roleTypes.ADMIN
                                                                    );
                                                                  },
                                                                );
                                                              if (
                                                                !hasAdminRole &&
                                                                warehouseItem
                                                                  .permissions
                                                                  ?.user
                                                              ) {
                                                                const hadOriginalPerms =
                                                                  hadOriginalUserPermissions(
                                                                    warehouseItem.warehouseId,
                                                                  );
                                                                const updatedPermissions =
                                                                  {
                                                                    ...warehouseItem.permissions,
                                                                  };
                                                                if (
                                                                  hadOriginalPerms &&
                                                                  originalUserPermissions[
                                                                    warehouseItem
                                                                      .warehouseId
                                                                  ]
                                                                ) {
                                                                  updatedPermissions.user =
                                                                    {
                                                                      ...originalUserPermissions[
                                                                        warehouseItem
                                                                          .warehouseId
                                                                      ],
                                                                    };
                                                                } else {
                                                                  Object.keys(
                                                                    updatedPermissions.user,
                                                                  ).forEach(
                                                                    (
                                                                      action,
                                                                    ) => {
                                                                      updatedPermissions.user[
                                                                        action
                                                                      ] = false;
                                                                    },
                                                                  );
                                                                }
                                                                setFieldValue(
                                                                  `warehouses[${index}].permissions`,
                                                                  updatedPermissions,
                                                                );
                                                              }
                                                            } else {
                                                              const hadOriginalPerms =
                                                                hadOriginalUserPermissions(
                                                                  warehouseItem.warehouseId,
                                                                );
                                                              if (
                                                                !hadOriginalPerms &&
                                                                warehouseItem
                                                                  .permissions
                                                                  ?.user
                                                              ) {
                                                                const warehouseHeadDefaultPerms =
                                                                  defaultPermissions.find(
                                                                    (rp) =>
                                                                      rp.roleType ===
                                                                      roleTypes.WAREHOUSE,
                                                                  );
                                                                if (
                                                                  warehouseHeadDefaultPerms
                                                                ) {
                                                                  const userEntityPermissions =
                                                                    warehouseHeadDefaultPerms.predefinedPermissions.find(
                                                                      (perm) =>
                                                                        perm.entity ===
                                                                        "user",
                                                                    );
                                                                  if (
                                                                    userEntityPermissions
                                                                  ) {
                                                                    const updatedPermissions =
                                                                      {
                                                                        ...warehouseItem.permissions,
                                                                      };
                                                                    Object.keys(
                                                                      updatedPermissions.user,
                                                                    ).forEach(
                                                                      (
                                                                        action,
                                                                      ) => {
                                                                        updatedPermissions.user[
                                                                          action
                                                                        ] =
                                                                          userEntityPermissions.actions.includes(
                                                                            action,
                                                                          );
                                                                      },
                                                                    );
                                                                    setFieldValue(
                                                                      `warehouses[${index}].permissions`,
                                                                      updatedPermissions,
                                                                    );
                                                                  }
                                                                }
                                                              }
                                                            }
                                                          }}
                                                          onBlur={handleBlur}
                                                          className="mb-2"
                                                        />
                                                      );

                                                      return (
                                                        <div className="role-checkbox-item">
                                                          {isDisabled &&
                                                          warehouseItem?.warehouseId ? (
                                                            <OverlayTrigger
                                                              trigger={[
                                                                "hover",
                                                                "focus",
                                                              ]}
                                                              placement="top"
                                                              overlay={popover}
                                                            >
                                                              <div>
                                                                {checkbox}
                                                              </div>
                                                            </OverlayTrigger>
                                                          ) : (
                                                            checkbox
                                                          )}
                                                        </div>
                                                      );
                                                    })()}
                                                  </div>
                                                  <ErrorMessage
                                                    name={`warehouses[${index}].isWarehouseHead`}
                                                    component="div"
                                                    className="text-danger small"
                                                  />
                                                </Col>
                                              )}
                                            </Row>

                                            {!isPartial && (
                                              <hr className="mt-4 mb-4" />
                                            )}
                                          </>
                                        )}

                                        {!isPartial && (
                                          <Row>
                                            <h5
                                              className="align-items-center mt-1 mb-4"
                                              id="permissions-section"
                                            >
                                              Permissions
                                            </h5>
                                            {formikErrors?.warehouses?.[index]
                                              ?.permissions &&
                                              touched?.warehouses?.[index]
                                                ?.permissions &&
                                              typeof formikErrors.warehouses[
                                                index
                                              ].permissions === "string" && (
                                                <div className="text-danger small mb-3">
                                                  {
                                                    formikErrors.warehouses[
                                                      index
                                                    ].permissions
                                                  }
                                                </div>
                                              )}

                                            {permissions
                                              .filter((permission) => {
                                                const selectedRoles =
                                                  options.filter((role) =>
                                                    warehouseItem.roles?.includes(
                                                      role.value,
                                                    ),
                                                  );
                                                if (
                                                  !selectedRoles ||
                                                  selectedRoles.length === 0
                                                )
                                                  return false;

                                                if (
                                                  permission.slug === "user"
                                                ) {
                                                  const hasAdminRole =
                                                    warehouseItem.roles?.some(
                                                      (rv) => {
                                                        const role =
                                                          options.find(
                                                            (opt) =>
                                                              opt.value === rv,
                                                          );
                                                        return (
                                                          role?.roleType ===
                                                          roleTypes.ADMIN
                                                        );
                                                      },
                                                    );
                                                  if (hasAdminRole) return true;

                                                  const hasWarehouseHeadRole =
                                                    warehouseItem.roles?.some(
                                                      (rv) => {
                                                        const role =
                                                          options.find(
                                                            (opt) =>
                                                              opt.value === rv,
                                                          );
                                                        return (
                                                          role?.label?.toLowerCase() ===
                                                            "warehouse-head" &&
                                                          role?.roleType ===
                                                            roleTypes.WAREHOUSE
                                                        );
                                                      },
                                                    );
                                                  if (!hasWarehouseHeadRole)
                                                    return false;
                                                  if (
                                                    warehouseItem.isWarehouseHead !==
                                                    1
                                                  )
                                                    return false;

                                                  if (
                                                    warehouseItem.warehouseId
                                                  ) {
                                                    const selectedWarehouse =
                                                      warehouseOptions?.find(
                                                        (wh) =>
                                                          wh.value ===
                                                          warehouseItem.warehouseId,
                                                      );
                                                    const isCurrentWarehouseHead =
                                                      warehouseHeads.some(
                                                        (wh) =>
                                                          wh.warehouseId ===
                                                          warehouseItem.warehouseId,
                                                      );
                                                    if (
                                                      !selectedWarehouse ||
                                                      (selectedWarehouse.defaultHead !==
                                                        0 &&
                                                        !isCurrentWarehouseHead)
                                                    )
                                                      return false;
                                                  } else {
                                                    return false;
                                                  }
                                                  return true;
                                                }

                                                return getPermissionsForRoles(
                                                  warehouseItem.roles,
                                                  options,
                                                ).includes(permission.slug);
                                              })
                                              .map((permission) => (
                                                <div
                                                  key={permission.id}
                                                  className="mb-4 mt-2"
                                                >
                                                  <Form.Label className="text-black">
                                                    {permission.label}
                                                  </Form.Label>
                                                  <div className="d-flex gap-4 flex-wrap mt-2">
                                                    {permission.permissions
                                                      .filter((perm) => {
                                                        const normalizedEntity =
                                                          String(
                                                            permission.slug ||
                                                              "",
                                                          )
                                                            .toLowerCase()
                                                            .trim();
                                                        const normalizedAction =
                                                          String(
                                                            perm.permission_slug ||
                                                              "",
                                                          )
                                                            .toLowerCase()
                                                            .trim();
                                                        if (
                                                          normalizedEntity ===
                                                            "warehouse" &&
                                                          (normalizedAction ===
                                                            "create" ||
                                                            normalizedAction ===
                                                              "delete")
                                                        ) {
                                                          const selectedRoleIds =
                                                            (
                                                              warehouseItem.roles ||
                                                              []
                                                            ).map((r) =>
                                                              r &&
                                                              typeof r ===
                                                                "object"
                                                                ? r.value
                                                                : r,
                                                            );
                                                          const hasAdminRole =
                                                            options.some(
                                                              (opt) =>
                                                                selectedRoleIds.some(
                                                                  (rid) =>
                                                                    String(
                                                                      rid,
                                                                    ) ===
                                                                    String(
                                                                      opt.value,
                                                                    ),
                                                                ) &&
                                                                (opt.roleType ===
                                                                  roleTypes.ADMIN ||
                                                                  opt.roleType ===
                                                                    roleTypes.SUPER_ADMIN),
                                                            );
                                                          return !!hasAdminRole;
                                                        }
                                                        return (
                                                          perm.display === true
                                                        );
                                                      })
                                                      .map((perm) => (
                                                        <label
                                                          key={
                                                            perm.permission_slug
                                                          }
                                                          className="d-flex align-items-center"
                                                        >
                                                          <Field
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            name={`warehouses[${index}].permissions.${permission.slug}.${perm.permission_slug}`}
                                                            checked={
                                                              warehouseItem
                                                                ?.permissions?.[
                                                                permission.slug
                                                              ]?.[
                                                                perm
                                                                  .permission_slug
                                                              ] || false
                                                            }
                                                            onChange={(e) => {
                                                              const isChecked =
                                                                e.target
                                                                  .checked;
                                                              const entityKey =
                                                                permission.slug;
                                                              const actionKey =
                                                                perm.permission_slug.toLowerCase();
                                                              const currentPermissions =
                                                                warehouseItem
                                                                  .permissions?.[
                                                                  entityKey
                                                                ] || {};
                                                              const updatedEntityPermissions =
                                                                {
                                                                  ...currentPermissions,
                                                                  [actionKey]:
                                                                    isChecked,
                                                                };

                                                              const requiresViewActions =
                                                                [
                                                                  "update",
                                                                  "delete",
                                                                  "status",
                                                                ];
                                                              const isViewAction =
                                                                actionKey ===
                                                                "view";

                                                              if (
                                                                !isViewAction
                                                              ) {
                                                                if (
                                                                  isChecked &&
                                                                  requiresViewActions.includes(
                                                                    actionKey,
                                                                  )
                                                                ) {
                                                                  updatedEntityPermissions[
                                                                    "view"
                                                                  ] = true;
                                                                } else if (
                                                                  !isChecked &&
                                                                  requiresViewActions.includes(
                                                                    actionKey,
                                                                  )
                                                                ) {
                                                                  const otherChecked =
                                                                    requiresViewActions.some(
                                                                      (act) =>
                                                                        act !==
                                                                          actionKey &&
                                                                        currentPermissions?.[
                                                                          act
                                                                        ],
                                                                    );
                                                                  if (
                                                                    !otherChecked &&
                                                                    !currentPermissions?.[
                                                                      "view"
                                                                    ]
                                                                  ) {
                                                                    updatedEntityPermissions[
                                                                      "view"
                                                                    ] = false;
                                                                  }
                                                                }
                                                              } else {
                                                                if (
                                                                  !isChecked
                                                                ) {
                                                                  const anyRequiredChecked =
                                                                    requiresViewActions.some(
                                                                      (act) =>
                                                                        currentPermissions?.[
                                                                          act
                                                                        ],
                                                                    );
                                                                  if (
                                                                    anyRequiredChecked
                                                                  )
                                                                    return;
                                                                }
                                                              }

                                                              setFieldValue(
                                                                `warehouses[${index}].permissions.${entityKey}`,
                                                                updatedEntityPermissions,
                                                              );
                                                            }}
                                                          />
                                                          <span className="ms-2">
                                                            {perm.label}
                                                          </span>
                                                        </label>
                                                      ))}
                                                  </div>
                                                </div>
                                              ))}
                                          </Row>
                                        )}
                                      </div>

                                      {isPartial && (
                                        <div className="warehouse-partial-overlay">
                                          <button
                                            type="button"
                                            className="warehouse-bounce-btn"
                                            title="Click to expand and see permissions"
                                            onClick={() =>
                                              toggleCollapseWarehouse(index)
                                            }
                                          >
                                            <svg
                                              width="16"
                                              height="16"
                                              viewBox="0 0 24 24"
                                              fill="none"
                                            >
                                              <path
                                                d="M6 9L12 15L18 9"
                                                stroke="white"
                                                strokeWidth="2.5"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                              />
                                            </svg>
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                    {!isPartial && (
                                      <div
                                        style={{ paddingBottom: "0.5rem" }}
                                      />
                                    )}
                                  </div>
                                )}
                              </Card.Body>
                            )}
                          </Card>
                        </div>
                      </Col>
                    </Row>
                  );
                })}

              {user && !loader && (
                <div className="d-flex justify-content-end mt-3 mb-4">
                  <Button
                    type="submit"
                    disabled={isSubmitting}
                    variant="btn btn-primary"
                  >
                    {isSubmitting ? "Updating..." : "Update"}
                  </Button>
                </div>
              )}
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default AccountEdit;
